import React, { createContext, useState, useEffect, useCallback, useContext } from 'react';
import { AuthContext } from './AuthContext';
import API_BASE_URL from '../config';
import { getToken } from '../utils/tokenUtils';

export const WalletContext = createContext();

export const WalletProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  const refreshWallet = useCallback(async () => {
    if (!user) return;
    
    setLoading(true);
    try {
      const rawToken = getToken();
      const response = await fetch(`${API_BASE_URL}/api/member/wallet`, {
        headers: {
          'Authorization': `Bearer ${rawToken}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const data = await response.json();
        setBalance(data.balance);
        setTransactions(data.transactions || []);
      }
    } catch (err) {
      console.error('Failed to load wallet', err);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      refreshWallet();
    } else {
      setBalance(0);
      setTransactions([]);
    }
  }, [user, refreshWallet]);

  return (
    <WalletContext.Provider value={{ balance, transactions, loading, refreshWallet }}>
      {children}
    </WalletContext.Provider>
  );
};
